module.exports = __webpack_public_path__ + "img/04_zhCn.d1a6e54e.png";